// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__cFJ2S","content":"Consent_content__5kIPA","footer":"Consent_footer__2Nj9N"};